import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  boxHeader: {
    width: ' 100%',
    display: 'flex',
    justifyContent: 'center',
  },
  imgLocandina: {
    [theme.fn.smallerThan('sm')]: {
      height: 'auto',
      width: '100%',
    },
  },
  title: {
    color: theme.white,
    fontSize: 60,
    fontWeight: 900,
    letterSpacing: -2,
    fontFamily: 'Avenir Next Heavy, sans-serif',

    [theme.fn.smallerThan('md')]: {
      fontSize: 50,
    },
  },
  subTitle: {
    color: '#F2F4FF',
    fontSize: 40,
    fontWeight: 500,
    fontFamily: 'Avenir Next Heavy, sans-serif',

    [theme.fn.smallerThan('md')]: {
      fontSize: 30,
    },
  },
  boxLocandina: {
    display: 'flex',
    justifyContent: 'center',
  },
}));
